module.exports = __webpack_public_path__ + "img/1_a9f8ae234.png";